/* eslint-disable @typescript-eslint/no-explicit-any */
import { unzipView } from "@/router/modules/view.apiunzip.module";
import { accessToken } from "@/services/utils/helper.util";
import { RouteLocationNormalized, NavigationGuardNext } from "vue-router";
// const jsonRoutes: { name: string; path: string }[] = [];
const jsonRoutes = unzipView;

const needLogin = (
  to: RouteLocationNormalized,
  _: unknown,
  next: NavigationGuardNext
) => {
  if (!accessToken?.value) {
    next({ name: "login-view" });
  } else {
    const index = jsonRoutes.find((item: any) => item?.name === to?.name);

    if (jsonRoutes && jsonRoutes.length > 0 && !index && to?.path === "/") {
      next({ name: jsonRoutes[0]?.name });
    } else {
      next();
    }
  }
};

const noNeedLogin = (
  to: RouteLocationNormalized,
  __: unknown,
  next: NavigationGuardNext
) => {
  if (accessToken?.value) {
    if (jsonRoutes && jsonRoutes.length > 0) {
      next({ name: jsonRoutes[0]?.name });
    } else {
      next({ path: "" });
    }
  } else {
    next();
  }
};

export { needLogin, noNeedLogin };
